import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

const FOOTER_COLS = [
  {
    title: "Services",
    links: [
      { to: "/services/press-release-distribution", label: "Press Release Distribution" },
      { to: "/services/content-syndication", label: "Content Syndication" },
      { to: "/services/guest-posting", label: "Guest Posting" },
      { to: "/services/high-end-backlinks", label: "High-End Backlinks" },
      { to: "/services/local-citations", label: "Local Citations" },
      { to: "/services/on-page-seo", label: "On-Page SEO" },
      { to: "/services/site-audit", label: "Site Audit" },
      { to: "/services/blog-content-plan", label: "Blog Content Plan" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/case-studies", label: "Case Studies" },
      { to: "/blog", label: "Blog" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/how-it-works", label: "How It Works" },
      { to: "/pricing", label: "Pricing" },
      { to: "/contact", label: "Free Consultation" },
      { to: "/contact", label: "Custom Quote" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/leads", { name: "Newsletter", email, type: "newsletter" });
      toast.success("Subscribed. Welcome to the list.");
      setEmail("");
    } catch (err) {
      toast.error("Couldn't subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-line bg-surfaceAlt/60 mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 space-y-5">
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-xl bg-ink text-white grid place-items-center">
                <Sparkles size={16} strokeWidth={2.2} />
              </div>
              <span className="font-display font-bold text-lg">Zenith Ranking</span>
            </div>
            <p className="text-sm text-inkSoft max-w-sm leading-relaxed">
              Scalable SEO & Digital PR services for agencies, freelancers, and brands. Order, track, and scale — all in one quiet workspace.
            </p>
            <div className="text-sm text-inkSoft">
              Contact: <a href="mailto:zenithranking27@gmail.com" className="text-terra hover:underline">zenithranking27@gmail.com</a>
            </div>
            <form onSubmit={subscribe} className="flex gap-2 max-w-sm" data-testid="footer-newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@agency.com"
                className="flex-1 h-11 px-4 rounded-xl border border-line bg-white text-sm outline-none focus:border-ink"
                data-testid="footer-newsletter-input"
              />
              <button type="submit" disabled={loading} className="btn-primary text-sm" data-testid="footer-newsletter-submit">
                {loading ? "..." : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-10">
            {FOOTER_COLS.map((col) => (
              <div key={col.title}>
                <div className="eyebrow mb-4">{col.title}</div>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.to} className="text-sm text-ink/80 hover:text-terra transition inline-flex items-center gap-1">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row gap-3 items-center justify-between text-xs text-inkSoft">
          <div>© {new Date().getFullYear()} Zenith Ranking. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <Link to="/contact" className="hover:text-ink inline-flex items-center gap-1">
              Book a strategy call <ArrowUpRight size={12} />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
